<template>
  <!-- eslint-disable vue/no-use-v-if-with-v-for,vue/no-confusing-v-for-v-if -->
  <div>
    <Loader v-if="loading"></Loader>
    <div class="wrraper" v-else>
      <!-- Start Breadcrumb -->
      <Breadcrumb
        :items="items"
        :show_print="true"
        :excelFile="true"
        :excelData="excelData"
      />
      <!-- End Breadcrumb -->
      <!-- start of searchSection  -->
      <SearchSection
        @filterTable="searchTable"
        title="تقارير العملاء"
      ></SearchSection>
      <!-- end of searchSection  -->
      <!-- notFound  -->
      <Notfound v-if="!searchItems"></Notfound>
      <!-- Start Statistics Card-->

      <div v-else>
        <ul class="all-state-count">
          <li>
            <div class="state-count">
              <span>عدد تقارير العملاء :</span>
              <span>{{ table_length }}</span>
            </div>
          </li>
        </ul>
        <!-- Start Statistics Card-->
        <h6 class="mt-7 mb-6 title-search" v-if="showReport">
          كشف حساب للعميل "{{ searchItems.userName }}" عن الفتره من "{{
            searchItems.from
          }}" الي "{{ searchItems.to }}"
        </h6>

        <!-- End Statistics Card-->
        <div class="table-print">
          <main class="main-table">
            <!-- start of  header of printSection  -->
            <PrintHead
              :title="'تقارير عميل'"
              :number="table_length"
            ></PrintHead>
            <!-- end of header of printSection  -->
            <v-data-table
              class="thumb"
              :headers="headers"
              :items="rows_without_pagenation"
              :loading="lodaing"
              :loading-text="$t('table.loadingData')"
              v-model="selected"
              :single-select="singleSelect"
              item-key="index"
              :items-per-page="rows_without_pagenation.length"
              hide-default-footer
            >
              <!-- ================== You Can use any slots you want ================== -->
              <!-- ====== Select row field ====== -->
              <!-- Select no data State -->
              <template v-slot:no-data>
                {{ $t("table.noData") }}
              </template>
              <template v-slot:[`item.index`]="{index}">
                {{ index + 1 }}
              </template>
              <template v-slot:[`item.type`]="{item}">
                <span v-if="item.type == 'transfer_wallet_in'">
                  إيداع خزنة
                </span>
                <span v-if="item.type == 'transfer_wallet_out'">سحب خزنة </span>
                <span v-if="item.type == 'transfer'"> تحويل خارجي </span>
                <span v-if="item.type == 'in'" class="greenColor"> إيداع </span>
                <span v-if="item.type == 'out'" class="redColor"> سحب </span>
                <span v-if="item.type == 'bank_in'"> إيداع بنكي </span>
                <span v-if="item.type == 'bank_out'"> سحب بنكي </span>
                <span v-if="item.type == 'currency_in'"> شراء عملة </span>
                <span v-if="item.type == 'currency_out'"> بيع عملة </span>
              </template>
              <template v-slot:[`item.commission`]="{item}">
                {{ item.commission }}
              </template>
              <template v-slot:[`item.rate`]="{item}">
                {{ item.rate }}
              </template>
              <template v-slot:[`item.amount`]="{item}">
                <span
                  :class="{
                    redColor: item.type == 'out',
                    greenColor: item.type == 'in',
                  }"
                >
                  {{ Number(item.amount).toLocaleString() }}
                </span>
              </template>
              <template v-slot:[`item.total`]="{item}">
                <span
                  :class="{
                    redColor: item.total < 0,
                    greenColor: item.total > 0,
                  }"
                >
                  {{ Number(item.total).toLocaleString() }}
                </span>
              </template>
              <template v-slot:[`item.da2en`]="{item}">
                <span
                  :class="{
                    greenColor: item.type == 'in',
                  }"
                >
                  {{ item.da2en }}
                </span>
              </template>
              <template v-slot:[`item.maden`]="{item}">
                <span
                  :class="{
                    redColor: item.type == 'out',
                  }"
                >
                  {{ item.maden }}
                </span>
              </template>
              <template v-slot:[`item.customer_amount_before`]="{item}">
                <span
                  :class="{
                    redColor: item.customer_amount_before < 0,
                    greenColor: item.customer_amount_before > 0,
                  }"
                >
                  {{ item.customer_amount_before }}
                </span>
              </template>
              <template v-slot:[`item.customer_amount_after`]="{item}">
                <span
                  v-if="
                    item.type == 'currency_in' || item.type == 'currency_out'
                  "
                >
                  ------
                </span>
                <span
                  :class="{
                    redColor: item.customer_amount_after < 0,
                    greenColor: item.customer_amount_after > 0,
                  }"
                  v-else
                >
                  {{ Number(item.customer_amount_after).toLocaleString() }}
                </span>
              </template>
              <template v-slot:[`item.notes`]="{item}">
                <div class="_actions">
                  <span v-if="item.notes == 'null' || item.notes == null">
                    ----
                  </span>
                  <v-icon
                    class="show"
                    small
                    v-else
                    @click="
                      modal.notesModalIsOpen = true;
                      setItemNotes(item.notes);
                    "
                  >
                    fal fa-eye
                  </v-icon>
                </div>
              </template>

              <!-- Select actions-->
              <template v-slot:[`item.actions`]="{item}">
                <div class="_actions">
                  <v-icon class="delete" small @click="deleteItem(item)">
                    fal fa-trash
                  </v-icon>
                </div>
              </template>

              <!-- ======================== Start Top Section ======================== -->
              <template v-slot:top>
                <!-- Delete dialog -->
                <v-dialog v-model="dialogDelete" max-width="500px">
                  <v-card>
                    <v-card-title class="text-h5 justify-center">{{
                      $t("table.deletedialog.areYouSure")
                    }}</v-card-title>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="#1B5E20" @click="deleteItemConfirm"
                        >{{ $t("table.deletedialog.ok") }}
                        <span
                          class="btn_loader_model"
                          v-if="loadingBtnDialog"
                        ></span
                      ></v-btn>
                      <v-btn color="#F44336" @click="dialogDelete = false">{{
                        $t("table.deletedialog.cancel")
                      }}</v-btn>
                      <v-spacer></v-spacer>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
                <!-- Add & Delete -->

                <!-- Description Modal -->
                <DescModal
                  :desc="selectedItemDesc"
                  :handelModalApperance="modal.descriptionModalIsOpen"
                  @close="closeDescModal"
                />

                <NotesModal
                  :desc="selectedItemNotes"
                  :handelModalApperance="modal.notesModalIsOpen"
                  @close="closeNotesModal"
                />
              </template>
              <!-- ======================== End Top Section ======================== -->
            </v-data-table>
          </main>
          <!-- ================== Start Pagination ==================== -->
          <!-- <div
            class="col-lg-12 text-center py-0 mb-5"
            v-if="
              !paginations.loaderPagenation &&
              !lodaing &&
              paginations.last_page != paginations.current_page
            "
          >
            <button class="button_style_1 m-auto" @click="pagenationScroll">
              تحميل المزيد
            </button>
          </div>
          <div class="loader" v-if="paginations.loaderPagenation" id="loader-4">
            <span></span>
            <span></span>
            <span></span>
          </div> -->
          <!-- ================== End Pagination ================== -->
          <div class="showMoney" v-if="showReport">
            <ul class="horizintal-ul">
              <li>
                <div class="state-count">
                  <span> {{ user_data[1].name }} : </span>
                  <span class="greenColor"
                    >{{ Number(user_data[1].value).toLocaleString() }}
                    {{ user_currency }}</span
                  >
                </div>
              </li>
              <li>
                <div class="state-count">
                  <span> {{ user_data[2].name }} : </span>
                  <span class="redColor"
                    >{{ Number(user_data[2].value).toLocaleString() }}
                    {{ user_currency }}</span
                  >
                </div>
              </li>
            </ul>
            <ul class="last_ul">
              <li style="width: 100%;">
                <div class="state-count">
                  <span> {{ user_data[0].name }} : </span>
                  <span
                    :class="{
                      redColor: user_data[0].value < 0,
                      greenColor: user_data[0].value > 0,
                    }"
                    >{{ Number(this.user_data[0].value).toLocaleString() }}
                    {{ user_currency }}
                    <span class="mr-2"> "{{ allAmount }}" </span></span
                  >
                </div>
              </li>
            </ul>
          </div>
        </div>
        <!-- ========================= start of table without pagenation  ========================== -->
        <!-- <TableWithoutPagenation
          :rows_without_pagenation="rows_without_pagenation"
          :showReport="showReport"
          :user_data="user_data"
          :allAmount="allAmount"
          :user_currency="user_currency"
        ></TableWithoutPagenation> -->
        <!-- ========================= end of table without pagenation  ========================== -->
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import StatsCard from "./../../../components/Charts/ChartComponent.vue";
import DescModal from "@/components/modals/DescriptionModal.vue";
import NotesModal from "@/components/modals/NotesModal.vue";
import SearchSection from "@/components/Search/clients-report";
// import TableWithoutPagenation from "./clients-print.vue";
import Tafgeet from "tafgeetjs";
export default {
  props: ["id"],

  components: {
    StatsCard,
    DescModal,
    NotesModal,
    SearchSection,
    // TableWithoutPagenation,
  },

  data() {
    return {
      // loadingBtnDialog
      loadingBtnDialog: false,
      // search
      searchItems: null,
      // loader
      loading: true,
      // ========== Breadcrumbs
      items: [
        {
          text: this.$t("breadcrumb.mainPage"),
          disabled: false,
          href: "/",
        },
        {
          text: "تقارير العملاء",
          disabled: true,
          href: "",
        },
      ],

      // ========== Statistics
      statisticsItems: [
        {
          id: 1,
          icon: "fal fa-images",
          title: "عمليات الإيداع",
          number: "10",
        },
      ],

      // ========== dialog Status
      dialogShow: false,
      itemToShow: null,
      dialogDelete: false,
      dialogDelete_selected: false,
      itemtoDelete: null,
      // ========== Date_Menues
      from_date_menu: false,
      to_date_menu: false,

      // ========== Filter
      filter: {
        name: null,
        safe: [],
        from: null,
        to: null,
      },

      // ========== Model
      model_1: {
        show_model: false,
        model_img_src: "",
      },

      // ========== Body Section
      calories: "",

      // ========== Your Data
      rows: [], // injected in created
      rows_without_pagenation: [],

      // ========== elected Data
      selected: [],
      singleSelect: false,

      // ========== Loding
      lodaing: false,

      // Fixed_data
      safes: ["foo", "bar", "fizz", "buzz"],
      // Custom Modal Data
      modal: {
        descriptionModalIsOpen: false,
        notesModalIsOpen: false,
      },
      // ========== pagination
      paginations: {
        current_page: 1,
        last_page: 1,
        items_per_page: 20,
        loaderPagenation: false,
      },

      selectedItemDesc: null,
      selectedItemNotes: null,
      table_length: null,
      user_data: null,
      showReport: false,
      allAmount: null,
      user_currency: null,
      // excel data
      excelData: {
        name: "تقارير العملاء",
        items: null,
        json_fields: {
          الحساب: "row_name",
          "نوع العملية": {
            field: "type",
            callback: (value) => {
              if (value == "expense") {
                return "مصروفات";
              } else if (value == "transfer_wallet_in") {
                return "إيداع خزنة";
              } else if (value == "transfer_wallet_out") {
                return "سحب خزنة";
              } else if (value == "transfer") {
                return "تحويل خارجي";
              } else if (value == "in") {
                return "إيداع";
              } else if (value == "out") {
                return "سحب";
              } else if (value == "bank_in") {
                return "إيداع بنكي";
              } else if (value == "bank_out") {
                return "سحب بنكي";
              } else if (value == "currency_in") {
                return "شراء عملة";
              } else if (value == "currency_out") {
                return "بيع عملة";
              }
            },
          },
          الخزنة: "wallet.name",
          المبلغ: {
            field: "amount",
            callback: (value) => {
              return Number(value).toLocaleString();
            },
          },
          العمولة: "commission",
          النسبة: "rate",
          دائن: "da2en",
          مدين: "maden",
          "الرصيد بعد العملية": {
            field: "customer_amount_after",
            callback: (value) => {
              return Number(value).toLocaleString();
            },
          },
          "تاريخ العملية": "created_at",
          وصف: "desc",
        },
        footer: null,
      },
    };
  },

  computed: {
    ...mapGetters({
      lang: "lang_module/lang",
    }),

    headers() {
      if (this.lang == "ar") {
        return [
          {
            text: "#",
            value: "index",
            sortable: false,
            align: "center",
            width: 10,
          },
          {
            text: "الحساب",
            value: "row_name",
            align: "center",
            width: 150,
          },
          {
            text: "نوع العملية",
            value: "type",
            align: "center",
            width: 120,
          },
          {
            text: "الخزنة",
            value: "wallet.name",
            align: "center",
            width: 120,
          },
          {
            text: "المبلغ",
            value: "amount",
            align: "center",
            sortable: false,
            width: 100,
          },
          {
            text: "العمولة",
            value: "commission",
            align: "center",
            sortable: false,
            width: 80,
          },
          {
            text: "النسبة",
            value: "rate",
            align: "center",
            sortable: false,
            width: 80,
          },
          {
            text: "دائن",
            value: "da2en",
            align: "center",
            sortable: false,
            width: 100,
          },
          {
            text: "مدين",
            value: "maden",
            align: "center",
            sortable: false,
            width: 100,
          },
          {
            text: "الرصيد بعد العملية",
            value: "customer_amount_after",
            align: "center",
            sortable: false,
            width: 150,
          },
          {
            text: "تاريخ العملية",
            value: "created_at",
            align: "center",
            width: 120,
          },
          {
            text: "وصف",
            value: "desc",
            align: "center",
            sortable: false,
            width: 300,
          },
        ];
      }
    },
  },

  methods: {
    // searchTable
    searchTable(items) {
      if (items.userName) {
        this.showReport = true;
      } else {
        this.showReport = false;
      }
      this.rows = [];
      this.rows_without_pagenation = [];
      this.searchItems = items;
      this.paginations.current_page = 1;
      this.setRows(this.paginations.current_page);
      this.setRowsWithoutPagenation();
    },
    // ==================== Start CRUD ====================
    addItem() {
      this.$router.push({
        path: this.id ? `/deposits/${this.id}/add` : `/deposits_ultimate/add`,
      });
    },
    showItem(item) {
      this.dialogShow = true;
      this.itemToShow = item;
    },
    editItem(item) {
      this.$router.push({path: "/deposits/edit/" + item.id});
    },
    // ===== Delete
    deleteItem(item) {
      this.dialogDelete = true;
      this.itemtoDelete = item;
    },
    deleteItemConfirm() {
      this.loadingBtnDialog = true;
      this.$axios({
        method: "DELETE",
        url: `CrudNsame/${this.itemtoDelete.id}`,
      })
        .then(() => {
          this.loadingBtnDialog = false;
          this.setRows(this.paginations.current_page);
          this.dialogDelete = false;
          this.$iziToast.success({
            timeout: 2000,
            message: this.$t("deleteSuccess"),
            position: "topRight",
          });
          this.$store.dispatch("getTranshState");
        })
        .catch((err) => {
          this.dialogDelete = false;
          this.$iziToast.error({
            timeout: 2000,
            message: err.response.data.message,
            position: "topRight",
          });
        });
    },
    // ==================== End CRUD ====================

    // Set Rows
    setRows() {
      this.allAmount = null;
      this.lodaing = true;
      this.$axios({
        method: "GET",
        url: "client/walletoperation/with_pagination",
        params: {
          type: "in",
          client_type: "customer",
          operation_type: "customer_report",
          page: this.paginations.current_page,
          balance_customer_id: this.searchItems
            ? this.searchItems.userId
            : null,
          type: this.searchItems ? this.searchItems.typeVal : null,
          wallet_id: this.searchItems ? this.searchItems.lockId : null,
          from_date: this.searchItems ? this.searchItems.from : null,
          to_date: this.searchItems ? this.searchItems.to : null,
        },
      })
        .then((res) => {
          this.lodaing = false;
          res.data.data.forEach((ele) => {
            this.rows.push(ele);
          });
          this.paginations.last_page = res.data.meta.last_page;
          this.paginations.items_per_page = res.data.meta.per_page;
          this.table_length = res.data.meta.total;
          this.paginations.loaderPagenation = false;
          this.rows.forEach((ele) => {
            if (ele.type == "currency_in" || ele.type == "currency_out") {
              ele["row_name"] = ele.person_name;
            } else {
              if (ele.balance_customer) {
                ele["row_name"] = ele.balance_customer.name;
              } else {
                ele["row_name"] = "------";
              }
            }
            if (
              ele.type == "bank_in" ||
              ele.type == "in" ||
              ele.type == "transfer" ||
              ele.type == "currency_in"
            ) {
              ele["da2en"] = Number(ele.total).toLocaleString();
            } else {
              ele["da2en"] = "-------";
            }
            if (
              ele.type == "bank_out" ||
              ele.type == "out" ||
              ele.type == "currency_out"
            ) {
              ele["maden"] = Number(ele.total).toLocaleString();
            } else {
              ele["maden"] = "-------";
            }
          });

          this.excelData.items = this.rows;
          this.user_data = res.data.user_data;
          this.user_currency = res.data.currency;
          if (this.user_data[0].value > 0) {
            var totalNum = Number(this.user_data[0].value);
          } else {
            var totalNum = Number(this.user_data[0].value.substring(1));
          }
          var Tafgeet = require("tafgeetjs");
          if (this.user_data[0].value > 0) {
            this.allAmount = new Tafgeet(totalNum, "").parse().substring(3);
            this.allAmount =
              this.allAmount.slice(0, this.allAmount.length - 7) +
              " " +
              this.user_currency +
              " " +
              "فقط لا غير";
          } else if (this.user_data[0].value < 0) {
            this.allAmount = new Tafgeet(totalNum, "").parse().substring(3);
            this.allAmount =
              "سالب" +
              " " +
              this.allAmount.slice(0, this.allAmount.length - 7) +
              " " +
              this.user_currency +
              " " +
              "فقط لا غير";
          } else {
            this.allAmount =
              "صفر" + " " + this.user_currency + " " + "فقط لا غير";
          }
          this.excelData.footer = [
            "إجمالي الإيداع : " +
              " " +
              Number(this.user_data[1].value).toLocaleString() +
              this.user_currency,
            "إجمالي السحب : " +
              " " +
              Number(this.user_data[2].value).toLocaleString() +
              this.user_currency,
            "رصيد العميل الحالي : " +
              " " +
              Number(this.user_data[0].value).toLocaleString() +
              this.user_currency +
              " " +
              `"${this.allAmount}"`,
          ];
        })
        .catch((err) => {
          this.lodaing = false;
          console.log(err.response.data.message);
        });
    },
    // Set Rows without pagenation
    setRowsWithoutPagenation() {
      this.allAmount = null;
      this.lodaing = true;
      this.$axios({
        method: "GET",
        url: "client/walletoperation",
        params: {
          type: "in",
          client_type: "customer",
          operation_type: "customer_report",
          balance_customer_id: this.searchItems
            ? this.searchItems.userId
            : null,
          type: this.searchItems ? this.searchItems.typeVal : null,
          wallet_id: this.searchItems ? this.searchItems.lockId : null,
          from_date: this.searchItems ? this.searchItems.from : null,
          to_date: this.searchItems ? this.searchItems.to : null,
        },
      })
        .then((res) => {
          this.lodaing = false;
          this.rows_without_pagenation = res.data.data;
          this.table_length = this.rows_without_pagenation.length;
          this.rows_without_pagenation.forEach((ele) => {
            if (ele.type == "currency_in" || ele.type == "currency_out") {
              ele["row_name"] = ele.person_name;
            } else {
              if (ele.balance_customer) {
                ele["row_name"] = ele.balance_customer.name;
              } else {
                ele["row_name"] = "------";
              }
            }
            if (
              ele.type == "bank_in" ||
              ele.type == "in" ||
              ele.type == "transfer" ||
              ele.type == "currency_in"
            ) {
              ele["da2en"] = Number(ele.total).toLocaleString();
            } else {
              ele["da2en"] = "-------";
            }
            if (
              ele.type == "bank_out" ||
              ele.type == "out" ||
              ele.type == "currency_out"
            ) {
              ele["maden"] = Number(ele.total).toLocaleString();
            } else {
              ele["maden"] = "-------";
            }
          });

          this.excelData.items = this.rows_without_pagenation;
          this.user_data = res.data.user_data;
          this.user_currency = res.data.currency;
          if (this.user_data[0].value > 0) {
            var totalNum = Number(this.user_data[0].value);
          } else {
            var totalNum = Number(this.user_data[0].value.substring(1));
          }
          var Tafgeet = require("tafgeetjs");
          if (this.user_data[0].value > 0) {
            this.allAmount = new Tafgeet(totalNum, "").parse().substring(3);
            this.allAmount =
              this.allAmount.slice(0, this.allAmount.length - 7) +
              " " +
              this.user_currency +
              " " +
              "فقط لا غير";
          } else if (this.user_data[0].value < 0) {
            this.allAmount = new Tafgeet(totalNum, "").parse().substring(3);
            this.allAmount =
              "سالب" +
              " " +
              this.allAmount.slice(0, this.allAmount.length - 7) +
              " " +
              this.user_currency +
              " " +
              "فقط لا غير";
          } else {
            this.allAmount =
              "صفر" + " " + this.user_currency + " " + "فقط لا غير";
          }
          this.excelData.footer = [
            "إجمالي الإيداع : " +
              " " +
              Number(this.user_data[1].value).toLocaleString() +
              this.user_currency,
            "إجمالي السحب : " +
              " " +
              Number(this.user_data[2].value).toLocaleString() +
              this.user_currency,
            "رصيد العميل الحالي : " +
              " " +
              Number(this.user_data[0].value).toLocaleString() +
              this.user_currency +
              " " +
              `"${this.allAmount}"`,
          ];
        })
        .catch((err) => {
          this.lodaing = false;
          console.log(err.response.data.message);
        });
    },
    setItemDesc(desc) {
      this.selectedItemDesc = desc;
    },
    setItemNotes(notes) {
      this.selectedItemNotes = notes;
    },
    closeDescModal() {
      this.modal.descriptionModalIsOpen = false;
    },
    closeNotesModal() {
      this.modal.notesModalIsOpen = false;
    },
    // pagenation with scroll
    pagenationScroll() {
      if (this.paginations.last_page != this.paginations.current_page) {
        this.paginations.loaderPagenation = true;
        this.paginations.current_page = this.paginations.current_page + 1;
        setTimeout(() => {
          this.setRows();
        }, 2000);
      }
    },
  },

  // ======= hooks
  created() {
    setTimeout(() => {
      this.loading = false;
    }, 1000);
    // permisions
    var userType = JSON.parse(this.$store.state.usertype) || null;
    if (
      !userType.includes("superadmin") &&
      !userType.includes("lock_and_deals") &&
      !userType.includes("clients_reports")
    ) {
      this.$router.push("/");
    }
  },
};
</script>

<style lang="scss" scoped></style>
